import { Table, TableBody, TableCell, TableHead } from '@mui/material';
import { GenericTableConfigDetailsDto } from 'inside-fifa/api/generic-tables/dto';

type TablePreviewProps = {
    currentLanguage: string;
    config: GenericTableConfigDetailsDto;
};

export const TablePreview = ({ currentLanguage, config }: TablePreviewProps) => {
    const relevantColumns = config.columns.filter((column) => !column.isHidden || column.shouldShowInExpandableRow);

    return (
        <Table size="small">
            <TableHead>
                {relevantColumns.map((column, index) => (
                    <TableCell key={index} style={{ textTransform: 'none' }}>
                        {column.columnTitle?.[currentLanguage] ?? column.title}
                    </TableCell>
                ))}
            </TableHead>
            <TableBody>
                {relevantColumns.map((_column, index) => (
                    <TableCell key={index}>...</TableCell>
                ))}
            </TableBody>
        </Table>
    );
};
